import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface GenerateAttendancePDFParams {
  classId: string;
  showBalance: boolean;
}

export const generateAttendancePDF = async (
  params: GenerateAttendancePDFParams,
) => {
  try {
    const resp = await baseAPI.post<Blob>('/attendance/generate-pdf', params, {
      responseType: 'blob',
    });
    return resp.data;
  } catch (error: any) {
    // If it's a blob error response, try to parse it as text to get the error message
    if (error.response?.data instanceof Blob) {
      const errorText = await error.response.data.text();
      const errorJson = JSON.parse(errorText);
      throw new Error(errorJson.error || 'Failed to generate PDF');
    }
    throw error;
  }
};

export const useGenerateAttendancePDFMutation = () => {
  return useMutation({
    mutationFn: async (params: GenerateAttendancePDFParams) => {
      const response = await generateAttendancePDF(params);
      return response;
    },
  });
};
